import React from 'react';
import { useTranslation } from 'react-i18next';
import { CommonDialog } from 'src/components/shared/dialog/CommonDialog';

export const FortuneExchangeSucceededDialog = () => {
  const { t } = useTranslation('fortune');
  const title = t('dialog_exchange_succeeded');
  const description = t('dialog_exchange_succeeded_desc');
  return <CommonDialog title={title} description={description} />;
};
